function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimpleArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer_2",
    width: 20,
    height: 20,
    "data-name": "Layer 2",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_17360",
    d: "M0 0H20V20H0z",
    "data-name": "Rectangle 17360",
    style: {
      opacity: 0,
      fill: "#004ab9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_4239",
    d: "M11.166 14.5a.833.833 0 0 1-.592-.242l-3.333-3.334a.837.837 0 0 1 1.183-1.183l2.742 2.759 2.75-2.65a.833.833 0 1 1 1.15 1.2l-3.333 3.217a.833.833 0 0 1-.567.233z",
    "data-name": "Path 4239",
    transform: "translate(-1.166 -1.583)",
    style: {
      fill: "#004ab9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleArrowDown);
export default __webpack_public_path__ + "static/media/simple-arrow-down.c8281ebcb4c38ca71720428be51aa618.svg";
export { ForwardRef as ReactComponent };